// A Kubernetes object's name (a DNS-1123 subdomain): dot-separated labels of
// lowercase letters, digits and hyphens, each starting and ending with a
// letter or digit. Argo CD names its Applications and AppProjects this way.
const OBJECT_NAME_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/;

// Kubernetes caps an object's name at 253 characters.
const OBJECT_NAME_MAX_LENGTH = 253;

/** What to enter when {@link isManagingApp} refuses a value. */
export const INVALID_MANAGING_APP =
  "Enter the Argo CD Application that manages argocd-rbac-cm as <project>/<application>, such as default/argocd. Both names are lowercase letters, digits, hyphens and dots.";

const isObjectName = (name: string) =>
  name.length <= OBJECT_NAME_MAX_LENGTH && OBJECT_NAME_PATTERN.test(name);

/**
 * Whether `app`, ignoring surrounding whitespace, names an Argo CD
 * Application as `<project>/<application>`: how Argo CD's RBAC names it, and
 * so how the customer's `p0-connector` policy lines name it.
 *
 * An Application in another namespace than Argo CD's own
 * (`<project>/<namespace>/<application>`) is refused: v1 doesn't support one.
 * No character here can split an RBAC line or open a Terraform interpolation.
 */
export const isManagingApp = (app: unknown): app is string => {
  if (typeof app !== "string") return false;
  const parts = app.trim().split("/");
  return parts.length === 2 && parts.every(isObjectName);
};
